import AIProcessorList from './AIProcessorList';
import AIProcessorCreate from './AIProcessorCreate';

export default {
  list: AIProcessorList,
  create: AIProcessorCreate,
  edit: AIProcessorCreate,
}
